import { Button, FormControl, InputLabel, MenuItem, Select, } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styles from "./addmembershipform.module.css";
import dayjs from "dayjs";
import { authData } from "../../admin/components/GetAuth";
import { StorageSetItem } from "../../admin/components/StorageComp";

const AddmembershipForm = ({ id, setAddMembershipModalShow, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [membershipList, setMembershipList] = useState([]);
    const [selectmembership, setSelectmembership] = useState([]);
    const [expireddate, setExpireddate] = useState("");

    const { register, handleSubmit, control, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            membership_id: ""
        }
    });

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "v1/membership-list", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                let itemData = response.data.data;
                setMembershipList(itemData);
            }
        });
    }, [API_TOKEN]);

    const getMember = (event) => {
        let selItem = membershipList.filter((i) => i.value === event);
        if (selItem.length) {
            setSelectmembership(selItem[0]);
            let expdate = selItem[0].duration.split(" ");
            let cur_date1 = dayjs().add(expdate[0], expdate[1]);
            setExpireddate(cur_date1.format("DD/MM/YYYY"));
        }
    }

    const onSubmitLocal = (data) => {
        if (id) {
            data.customer_id = id;
        }
        if (selectmembership?.duration) {
            data.duration = selectmembership?.duration;
        }
        const postData = data;
        setLoading(true);
        setAddMembershipModalShow(false);

        axios.post(process.env.REACT_APP_API_URL + "v1/add-membership", postData, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then((response) => {
            setLoading(false);
            if (response.data.status === "SUCCESS") {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType("success");

                if (auth) {
                    let authTemp = auth;
                    let customerData = authTemp?.customer;
                    if (customerData) {
                        customerData = { ...customerData, discount_val: response.data.data2?.discount_val, membership_discount: response.data.data2?.membership_discount, membership_duration: response.data.data2?.membership_duration, membership_expired_date: response.data.data2?.membership_expired_date };
                    }
                    authTemp = { ...authTemp, customer: customerData };
                    StorageSetItem("bookAuthData", authTemp, 24 * 60 * 60 * 1000);
                }
            }
            if (response.data.status === "ERROR") {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType("error");
            }
        }).catch((error) => {
            setLoading(false);
            if (error && error.response && error.response.data && error.response.data.messages) {
                setSnackbarOpen(true);
                setSnackbarMessage(error.response.data.messages);
                setSnackbarType("error");
            }
        });

    }

    return (<form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={styles.FormMainRow}>
            <div className={styles.FormGroupFull}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Membership*</InputLabel>
                    <Controller
                        control={control}
                        {...register("membership_id", {
                            required: "This field is Required",
                        })}
                        render={({ field }) => (<Select
                            {...field}
                            label="Membership*"
                            onChange={(e) => {
                                field.onChange(e);
                                getMember(e.target.value);
                            }}
                        >
                            {membershipList?.map((i) => {
                                return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
                            })}
                        </Select>)}
                    />
                </FormControl>
                {errors.membership_id && (<span className={styles.ErrorM}>{errors?.membership_id?.message}</span>)}
            </div>

            {selectmembership?.duration && (
                <div className={styles.FormGroupFull}>
                    <p className={styles.SummaryTitle}>Plan summary</p>
                    <div className={styles.SummaryCard}>
                        <div className={styles.SummaryRow}>
                            <span className={styles.SummaryLabel}>Duration</span>
                            <span className={styles.SummaryValue}>{selectmembership?.duration}</span>
                        </div>
                        {selectmembership?.discount && (
                            <div className={styles.SummaryRow}>
                                <span className={styles.SummaryLabel}>Discount</span>
                                <span className={`${styles.SummaryValue} ${styles.Discount}`}>{selectmembership?.discount}%</span>
                            </div>
                        )}
                        <div className={styles.SummaryRow}>
                            <span className={styles.SummaryLabel}>Renews / expires</span>
                            <span className={styles.SummaryValue}>{expireddate}</span>
                        </div>
                        {selectmembership?.price && (
                            <div className={styles.SummaryRow}>
                                <span className={styles.SummaryLabel}>Price</span>
                                <span className={`${styles.SummaryValue} ${styles.Price}`}>&pound;{selectmembership?.price}</span>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>

        <div className={styles.ModalActions}>
            <Button className={styles.ModalBtnGhost} onClick={(e) => setAddMembershipModalShow(false)}>Cancel</Button>
            <Button className={styles.ModalBtnPrimary} type="submit">Subscribe</Button>
        </div>
    </form>);
};

export default AddmembershipForm;